const dedupe = (values: string[]): string[] => [...new Set(values)];

export const normalizeLabelValues = (values: string[]): string[] =>
  dedupe(values);

export const parseLabelValueInput = (input: string): string[] =>
  dedupe(
    input
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean),
  );

export const mergeLabelValues = (
  existingValues: string[],
  newValues: string[],
): string[] => dedupe([...existingValues, ...newValues]);

export const replaceLabelValue = (
  values: string[],
  index: number,
  value: string,
): string[] =>
  dedupe(
    values
      .map((currentValue, currentIndex) =>
        currentIndex === index ? value.trim() : currentValue,
      )
      .filter(Boolean),
  );
